import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  supplierFrom: string;  // supplier code lower bound (12 chars)
  supplierTo: string;    // supplier code upper bound
  yearMonFrom: string;   // year-month lower bound (YYYY/MM)
  yearMonTo: string;     // year-month upper bound (YYYY/MM)
  deptFrom: string;      // department code lower bound (4 chars)
  deptTo: string;        // department code upper bound
  buyerFrom: string;     // buyer code lower bound (8 chars)
  buyerTo: string;       // buyer code upper bound
  reportType: string;    // "deptSupplier" or "supplierDept"
}

export interface APOffsetRow {
  deptCode: string;
  deptName: string;
  supplierCode: string;
  supplierName: string;
  buyerCode: string;
  buyerName: string;
  yearMonth: string;
  currency: string;
  amountDue: number;
  amountPaid: number;
}

export interface CurrencySummary {
  groupKey: string;
  currency: string;
  amountDue: number;
  amountPaid: number;
}

export interface GrandTotal {
  currency: string;
  amountDue: number;
  amountPaid: number;
}

export interface QueryResponse {
  details: APOffsetRow[];
  summaries: CurrencySummary[];
  totals: GrandTotal[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const h303Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/h303/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/h303/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
